import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import classNames from "classnames";
// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
// sections of this Page

import sectionsPageStyle from "assets/jss/material-kit-pro-react/views/sectionsPageStyle.js";

import TeamT5 from "components/ManualOrder/TeamT5";

const useStyles = makeStyles(sectionsPageStyle);

export default function ManualOrderPage() {
	const classes = useStyles();

	return (
		<div>
			<Header
				color="info"
				brand="Auscomp Cloud Services"
				links={<HeaderLinks dropdownHoverColor="info" />}
				fixed
			/>
			<div className={classNames(classes.main, classes.marginTop)}>
				<TeamT5 />
			</div>
		</div>
	);
}
